export default __webpack_public_path__ + "static/bg-tower-cfc87280a2dbbee8032ba780608d82e1.webp";